import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=3888f32d&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"
import style0 from "../styles/Profile.css?vue&type=style&index=0&id=3888f32d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3888f32d",
  null
  
)

export default component.exports